import { render } from "./HeroiconsOutlineFolderDownload.vue?vue&type=template&id=ac6bd2d2"
const script = {}

import exportComponent from "/Users/taylor/Documents/Code/laravel-nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineFolderDownload.vue"]])

export default __exports__